import { type ReactNode } from 'react';

import styles from './IngredientContainer.module.css';

interface Props {
  testid?: string;
  children: ReactNode;
}

export function IngredientContainer(props: Props) {
  const { children, testid } = props;
  return (
    <div className={styles.container} data-testid={testid}>
      {children}
    </div>
  );
}
